<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:cancel="cancelHandler"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PatternSetupForm from "../../../components/attendance/patternsetup/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": PatternSetupForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setuppattern.editpatternsetup'),
      pageTitleValue: "",
      formData: {
        id: null,
        code: null,
        name: null,
        cycledays: null,
        remark: null,
        rdaygzactionid:  null,
        rdayngzactionid: null,
        ofdaygzactionid:  null,
        ofdayngzactionid: null,
        disable: false,
        patternd: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      loading: true,
      editMode: false,
      isConfirm: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadPatternHandler() {
      const vm = this;

      return this.$store.dispatch("get", { url: "/patternsetup/" + vm.id })
        .then(res => {
          const rec = res.data.rec[0];

          vm.formData.id = rec.id;
          vm.formData.code = rec.code;
          vm.formData.name = rec.name;
          vm.formData.cycledays = rec.cycledays;
          vm.formData.remark = rec.remark;
          vm.formData.rdaygzactionid  = rec.rdaygzactionid;
          vm.formData.rdayngzactionid = rec.rdayngzactionid;
          vm.formData.ofdaygzactionid  = rec.ofdaygzactionid;
          vm.formData.ofdayngzactionid = rec.ofdayngzactionid;
          vm.formData.disable = rec.disable == 1 ? true : false;
          vm.formData.stamp = rec.stamp;

          vm.pageTitleValue = rec.name;

          vm.formData.patternd = res.data.patternd.map(d => ({
            id: d.id,
            patternid: d.patternid,
            sequenceno: d.sequenceno,
            shiftid: d.shiftid,
            shiftcode: d.shiftcode,
            shiftdesc: d.shiftdesc,
            daytypeid: d.daytypeid,
            daytypecode: d.daytypecode,
            daytypedesc: d.daytypedesc,
            stamp: d.stamp,
            action: 2,
          }));

          vm.loading = false;
        })
        .catch(err => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      if (this.formData.disable == false || this.formData.disable == null) {
        this.formData.disable = 0;
      } else {
        this.formData.disable = 1;
      }

      this.$store.dispatch("put", { url: "/patternsetup/" + vm.id, payload: this.formData })
        .then(res => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "patternsetuplist", params: { search: this.search } });
          }
        })
        .catch(err => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "patternsetuplist" });
    },

    deleteHandler($event) {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      this.isConfirm = !this.isConfirm;

      if ($event) {
        this.$store.dispatch("delete", {
          url: "/patternsetup/" + this.id + "/" + this.formData.userid,
        })
          .then(res => {
            if (res.data.error) {
              vm.isErr = true;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "patternsetuplist" });
            }
          })
          .catch(err => {
            vm.isErr = true;
            vm.errMsg = err;
          });
      }
    },

    createHandler() {
      this.$router.push({ name: "patternsetupnew" });
    },
  },

  async mounted() {
    this.editMode = true;
    await this.loadPatternHandler();
  },
};
</script>
